import React from 'react';
import ProfileLayout from '../../../layout/profile';
import ClientEmailById from './ClientEmailById';

export default function Email () {
    return (
        <ProfileLayout>
            <ClientEmailById />
        </ProfileLayout>
    );
}
